import { WhichWeightAPI } from 'WhichWeightAPI'
// import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { useState } from 'react'
import { useSelector } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
import { equipmentOptions } from 'functions/equipmentUtils'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { ShoppingCartIcon } from '@heroicons/react/24/outline'
import { GetPrimaryColorHex } from 'redux/slices/brand'
// import { GetAppWorkoutStatus } from 'redux/selectors/AppWorkoutStatusSelector'

import SolidButton from 'components/Buttons/SolidButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'
import WeightAvailabilitySection from 'components/Equipment/WeightAvailabilitySection'
import ContentFrame from 'components/Frame/ContentFrame'

export default function EquipmentProfileModifyComponent({
    modificationKey = 'create',
    propEquipmentProfile = null,
    NavigationAction = () => { console.log('Add a navigation action') }
}) {
    // const navigate = useNavigate()

    // const { ShowModal } = useContext(ModalContext)

    // const appWorkoutStatus = GetAppWorkoutStatus()

    const styleConfig = useSelector((state) => state.brand.styleConfig)
    const profileType = useSelector(state => state.athleteProfile.profileType)
    const groupId = useSelector(state => state.athleteProfile.groupId)
    const athleteId = useSelector((state) => state.athleteProfile.userId)
    const trainingChartPresentDate = useSelector((state) => state.athleteProfile.trainingChartPresentDate)
    const measurementSystem = 'imperial'

    const [title, setTitle] = useState(propEquipmentProfile?.name || '')
    const [titleError, setTitleError] = useState('')
    const [description, setDescription] = useState(propEquipmentProfile?.description || '')
    const [equipmentProfileJSON, setEquipmentProfileJSON] = useState(propEquipmentProfile ? JSON.parse(propEquipmentProfile.equipmentProfileJSON) : null)
    const [isActive, setIsActive] = useState(false)
    const [activateLoading, setActivateLoading] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)

    const [isEquipmentListExpanded, setIsEquipmentListExpanded] = useState(false)
    const [isPlateExpanded, setIsPlateExpanded] = useState(false)
    const [isDumbbellExpanded, setIsDumbbellExpanded] = useState(false)
    const [isKettlebellExpanded, setIsKettlebellExpanded] = useState(false)

    const max_plate_quantity = 4
    const max_dumbbell_quantity = 2
    const max_kettlebell_quantity = 2

    const mutateEquipmentProfile = (mutationKey, equipmentKey, index = 0) => {
        const updatedProfile = JSON.parse(JSON.stringify(equipmentProfileJSON))

        switch (mutationKey) {
            case 'toggle-base-equipment':                
                updatedProfile.baseEquipment[equipmentKey] = !updatedProfile.baseEquipment[equipmentKey]
                break
            
            case 'increment-weight-availability':
                switch (equipmentKey) {
                    case 'plate':
                        if (updatedProfile.plateAvailability[index].quantity < max_plate_quantity) {
                            updatedProfile.plateAvailability[index].quantity += 1
                        }
                        break

                    case 'dumbbell':
                        if (updatedProfile.dumbbellAvailability[index].quantity < max_dumbbell_quantity) {
                            updatedProfile.dumbbellAvailability[index].quantity += 1
                        }
                        break

                    case 'kettlebell':
                        if (updatedProfile.kettlebellAvailability[index].quantity < max_kettlebell_quantity) {
                            updatedProfile.kettlebellAvailability[index].quantity += 1
                        }
                        break
                }
                break

            case 'decrement-weight-availability':
                switch (equipmentKey) {
                    case 'plate':
                        if (updatedProfile.plateAvailability[index].quantity > 0) {
                            updatedProfile.plateAvailability[index].quantity -= 1
                        }
                        break

                    case 'dumbbell':
                        if (updatedProfile.dumbbellAvailability[index].quantity > 0) {
                            updatedProfile.dumbbellAvailability[index].quantity -= 1
                        }
                        break

                    case 'kettlebell':
                        if (updatedProfile.kettlebellAvailability[index].quantity > 0) {
                            updatedProfile.kettlebellAvailability[index].quantity -= 1
                        }
                        break
                }
                break

            case 'add-all-weight-availability':
                switch (equipmentKey) {
                    case 'plate':
                        updatedProfile.plateAvailability.forEach(item => {
                            item.quantity = max_plate_quantity
                        })
                        break

                    case 'dumbbell':
                        updatedProfile.dumbbellAvailability.forEach(item => {
                            item.quantity = max_dumbbell_quantity
                        })
                        break

                    case 'kettlebell':
                        updatedProfile.kettlebellAvailability.forEach(item => {
                            item.quantity = max_kettlebell_quantity
                        })
                        break
                }

                break

            case 'remove-all-weight-availability':
                switch (equipmentKey) {
                    case 'plate':
                        updatedProfile.plateAvailability.forEach(item => {
                            item.quantity = 0
                        })
                        break

                    case 'dumbbell':
                        updatedProfile.dumbbellAvailability.forEach(item => {
                            if (item.weight <= 20) { item.quantity = 2
                            } else { item.quantity = 0 }
                        })
                        break

                    case 'kettlebell':
                        updatedProfile.kettlebellAvailability.forEach(item => {
                            item.quantity = 0
                        })
                        break
                }
                break
        }

        setEquipmentProfileJSON(updatedProfile)
    }

    /*
    const ShowActiveWorkoutWarningModal = () => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            titleText: 'Unable to Continue',
            bodyText: [
                'Please complete your currently active workout before continuing',
                'You can resume or end your current active workout from the home screen',
                'Please contact support@kinesisintegrated.com with for further support',
            ],
            buttonText: 'Go To Home Screen',
            buttonAction: () => navigate('/home'),
        }

        ShowModal(modalData)
    }
    */

    const OnSaveNewEquipmentProfile = async () => {

        // Validate workout status
        // if (appWorkoutStatus !== 'empty') { ShowActiveWorkoutWarningModal(); return; }

        // Validate name
        if (title.length === 0) { setTitleError('Name is required'); return }
        setTitleError('')

        setSaveLoading(true)

        if (profileType === 'group') {
            const jsonBody = {
                groupId: groupId,
                name: title,
                description: description,
                activateOnSave: isActive ? 1 : 0,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/create_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setSaveLoading(false)
                console.error(result)
                return
            }
        }

        if (profileType === 'individual') {
            const jsonBody = {
                userId: athleteId,
                name: title,
                description: description,
                activateOnSave: isActive ? 1 : 0,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/create_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setSaveLoading(false)
                console.error(result)
                return
            }
        }

        setSaveLoading(false)

        window.location.reload()
    }

    const OnActivateProfile = async () => {

        // Validate workout status
        // if (appWorkoutStatus !== 'empty') { ShowActiveWorkoutWarningModal(); return; }

        setActivateLoading(true)

        if (profileType === 'group') {
            const jsonBody = {
                groupId: groupId,
                equipmentProfileId: propEquipmentProfile.id,
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'POST', '/activate_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setActivateLoading(false)
                console.error(result)
                return
            }
        }

        if (profileType === 'individual') {
            const jsonBody = {
                userId: athleteId,
                equipmentProfileId: propEquipmentProfile.id,
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/activate_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setActivateLoading(false)
                console.error(result)
                return
            }
        }

        setActivateLoading(false)

        window.location.reload()
    }

    const OnSaveEquipmentProfileChanges = async () => {

        // Validate workout status
        // if (appWorkoutStatus !== 'empty') { ShowActiveWorkoutWarningModal(); return; }

        // Validate name
        if (title.length === 0) { setTitleError('Name is required'); return }
        setTitleError('')

        setSaveLoading(true)

        if (profileType === 'group') {

            const jsonBody = {
                groupId: groupId,
                equipmentProfileId: propEquipmentProfile.id,
                name: title,
                description: description,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/update_group_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setSaveLoading(false)
                console.error(result)
                return
            }

        }

        if (profileType === 'individual') {

            const jsonBody = {
                userId: athleteId,
                equipmentProfileId: propEquipmentProfile.id,
                name: title,
                description: description,
                equipmentProfileJSON: JSON.stringify(equipmentProfileJSON)
            }
            
            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'PATCH', '/update_equipment_profile', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setSaveLoading(false)
                console.error(result)
                return
            }

        }

        setSaveLoading(false)

        window.location.reload()
    }

    return (
        <>
            <div className="flex items-center gap-x-4">
                {modificationKey === 'create' && <div className="flex-1">Create Equipment Profile</div>}

                {modificationKey === 'edit' && <div className="flex-1">Edit Equipment Profile</div>}

                <div className="w-40">
                    <SolidButton
                        size='extra-small'
                        text="Cancel"
                        action={() => NavigationAction('/equipmentProfile/view', null)}
                        className="shadow-md"
                    />
                </div>

                {modificationKey === 'create' &&
                    <div className="w-40">
                        <BrandColorButton
                            size='extra-small'
                            text="Save"
                            action={OnSaveNewEquipmentProfile}
                            isLoading={saveLoading}
                            className="shadow-md"
                        />
                    </div>
                }

                {modificationKey === 'edit' &&
                    <>
                        {propEquipmentProfile.active === 0 &&
                            <div className="w-40">
                                <SolidButton 
                                    size='extra-small'
                                    text="Activate Profile"
                                    action={OnActivateProfile}
                                    isLoading={activateLoading}
                                    className="shadow-md"
                                />
                            </div>
                        }

                        <div className="w-40">
                            <BrandColorButton 
                                size='extra-small'
                                text="Save" 
                                action={OnSaveEquipmentProfileChanges} 
                                isLoading={saveLoading} 
                                className="shadow-md"
                            />    
                        </div>
                    </>
                }
            </div>

            <div className='max-w-xl mx-auto'>
                <ContentFrame>
                    <div className='w-full p-4 space-y-4'>
                        {/* Name */}
                        <div className='space-y-1'>
                            <div className='flex px-2'>
                                <p className='flex-grow text-xs font-bold text-gray-500'>Name*</p>
                                <p className="text-xs text-gray-500">{title.length}/100 characters</p>
                            </div>
                            <input
                                type="text"
                                className="w-full h-12 rounded-full bg-gray-100 px-4 text-gray-900 placeholder:text-gray-400 focus:outline-none"
                                placeholder='Enter profile name here'
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value.slice(0, 100))
                                    setTitleError('')
                                }}
                            />
                            {titleError && <p className="pl-2 mt-1 text-sm text-red-500">{titleError}</p>}
                        </div>

                        {/* Description */}
                        <div className='space-y-1'>
                            <div className='flex px-2'>
                                <p className='flex-grow text-xs font-bold text-gray-500'>Description</p>
                                <p className="text-xs text-gray-500">{description.length}/200 characters</p>
                            </div>
                            <textarea
                                id="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value.slice(0, 200))}
                                placeholder="Enter profile description"
                                rows={3}
                                className="w-full p-4 bg-gray-100 rounded-xl focus:outline-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] "
                                maxLength={200}
                            />
                        </div>

                        {/* Base Equipment Section */}
                        <div className="bg-gray-100 rounded-lg overflow-hidden divide-y divide-gray-300 cursor-pointer">
                            <div 
                                className="flex items-center justify-between px-6 py-4"
                                onClick={() => setIsEquipmentListExpanded(!isEquipmentListExpanded)}
                            >
                                <div className="flex items-center gap-x-2">
                                    <span className="text-base font-semibold text-gray-800">Equipment Availability</span>

                                    <span className="text-xs text-gray-500">
                                        ({equipmentOptions.filter(equipment => Object.keys(equipmentProfileJSON.baseEquipment).includes(equipment.key) === false || equipmentProfileJSON.baseEquipment[equipment.key]).length} of {equipmentOptions.length})
                                    </span>
                                </div>

                                <ChevronDownIcon 
                                    className={`
                                        h-5 w-5 text-gray-500 transform transition-transform duration-200 
                                        ${isEquipmentListExpanded ? 'rotate-180' : ''}
                                    `}
                                />
                            </div>

                            {isEquipmentListExpanded && (
                                <>
                                    {equipmentOptions.map((equipment, index) => (
                                        <div 
                                            key={index}
                                            className='flex items-center p-4'
                                            onClick={() => {
                                                // Only allow toggling if the equipment already in the profile base equipment list
                                                if (Object.keys(equipmentProfileJSON.baseEquipment).includes(equipment.key)) {
                                                    mutateEquipmentProfile('toggle-base-equipment', equipment.key)
                                                }
                                            }}
                                        >
                                            <div className="flex-1 flex items-center gap-x-3">
                                                <img src={equipment.imageURL} alt="Equipment Icon" className="h-8 w-8" />

                                                <div>
                                                    <div className="flex items-center gap-x-2">
                                                        <span className="text-sm">{equipment.name}</span>
                                                        {/* <span className="text-xs text-gray-400">({equipment.required ? 'Required' : 'Optional'})</span> */}
                                                    </div>
                                                    <div className="text-xs text-gray-500">{equipment.description}</div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-x-4">
                                                {Object.keys(equipmentProfileJSON.baseEquipment).includes(equipment.key) &&
                                                    <div 
                                                        className='w-8 h-4 rounded-full p-0.5 transition-colors duration-200 ease-in-out'
                                                        style={{
                                                            backgroundColor: equipmentProfileJSON.baseEquipment[equipment.key] ? GetPrimaryColorHex(styleConfig) : '#e5e7eb'
                                                        }}
                                                    >
                                                        <div 
                                                            className={`w-3 h-3 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${
                                                                equipmentProfileJSON.baseEquipment[equipment.key] ? 'translate-x-4' : 'translate-x-0'
                                                            }`}
                                                        />
                                                    </div>
                                                }

                                                {/* Display items not in the base equipment list as active but disabled */}

                                                {!Object.keys(equipmentProfileJSON.baseEquipment).includes(equipment.key) &&
                                                    <div 
                                                        className='w-8 h-4 rounded-full p-0.5 transition-colors duration-200 ease-in-out opacity-25'
                                                        style={{
                                                            backgroundColor: true ? GetPrimaryColorHex(styleConfig) : '#e5e7eb'
                                                        }}
                                                    >
                                                        <div 
                                                            className={`w-3 h-3 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${
                                                                true ? 'translate-x-4' : 'translate-x-0'
                                                            }`}
                                                        />
                                                    </div>
                                                }

                                                <div
                                                    className="text-gray-500 rounded-md p-2"
                                                    onClick={(e) => { e.stopPropagation(); window.open(equipment.shoppingLink, '_blank') }}
                                                >
                                                    <ShoppingCartIcon className="h-5 w-5" />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                        
                        {/* Weight Availability Section. Imperial Only */}
                        {measurementSystem === 'imperial' && 
                            <>
                                <WeightAvailabilitySection
                                    equipmentKey="plate"
                                    title="Plate Availability"
                                    iconUrl="https://which-weight-public.s3.us-east-2.amazonaws.com/equipment_icons/barbell.png"
                                    availabilityJSON={equipmentProfileJSON.plateAvailability}
                                    maxQuantity={max_plate_quantity}
                                    mutateEquipmentProfile={mutateEquipmentProfile}
                                    isExpanded={isPlateExpanded}
                                    onToggleExpand={() => setIsPlateExpanded(!isPlateExpanded)}
                                />
                                
                                <WeightAvailabilitySection
                                    equipmentKey="dumbbell"
                                    title="Dumbbell Availability"
                                    iconUrl="https://which-weight-public.s3.us-east-2.amazonaws.com/equipment_icons/dumbbell.png"
                                    availabilityJSON={equipmentProfileJSON.dumbbellAvailability}
                                    maxQuantity={max_dumbbell_quantity}
                                    mutateEquipmentProfile={mutateEquipmentProfile}
                                    isExpanded={isDumbbellExpanded}
                                    onToggleExpand={() => setIsDumbbellExpanded(!isDumbbellExpanded)}
                                />

                                <WeightAvailabilitySection
                                    equipmentKey="kettlebell"
                                    title="Kettlebell Availability"
                                    iconUrl="https://which-weight-public.s3.us-east-2.amazonaws.com/equipment_icons/kettlebell.png"
                                    availabilityJSON={equipmentProfileJSON.kettlebellAvailability}
                                    maxQuantity={max_kettlebell_quantity}
                                    mutateEquipmentProfile={mutateEquipmentProfile}
                                    isExpanded={isKettlebellExpanded}
                                    onToggleExpand={() => setIsKettlebellExpanded(!isKettlebellExpanded)}
                                />
                            </>
                        }

                        {/* Auto activate toggle */}
                        {modificationKey === 'create' && 
                            <div 
                                className="flex items-center justify-between rounded-xl p-4 bg-gray-100 gap-x-2 cursor-pointer"
                                onClick={() => setIsActive(!isActive)}
                            >
                                <div className='space-y-1'>
                                    <label className="text-sm font-semibold text-gray-700">Activate this equipment profile</label>
                                    <p className="text-xs text-gray-500">Automatically make this the active equipment profile when saved</p>
                                </div>

                                <div>
                                    <div 
                                        className='w-12 h-6 rounded-full p-0.5 transition-colors duration-200 ease-in-out'
                                        style={{
                                            backgroundColor: isActive ? GetPrimaryColorHex(styleConfig) : '#e5e7eb'
                                        }}
                                    >
                                        <div 
                                            className={`
                                                w-5 h-5 rounded-full bg-white transform transition-transform duration-200 ease-in-out 
                                                ${isActive ? 'translate-x-6' : 'translate-x-0'}
                                            `}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </ContentFrame>
            </div>
        </>
    )
}